function toSlug(title) {
	return title
		.toLowerCase() // make lowercase
		.trim() // remove spaces at start/end
		.replace(/\s+/g, "-") // replace spaces with hyphens
		.replace(/[^a-z0-9\-]/g, ""); // remove special characters
}

document
	.querySelectorAll(".faqs-page-template h5.faqs-title")
	.forEach((title) => {
		const slug = toSlug(title.textContent);
		title.setAttribute("id", slug);
	});

document.querySelectorAll(".faqs-page-template .sidebar a").forEach((link) => {
	const text = link.textContent;
	link.setAttribute("href", "#" + toSlug(text));
});
